export class Checklist {
    checkListItemId: number;
    masterTaskId: number;
    description: string;
    sequence: number;
    __index: number;
}
